export const endDateCheckErrorsOnChange = (
  startDate: Date,
  endDate: Date,
  setFieldError: (field: string, message: string | undefined) => void,
) => {
  if (startDate) {
    if (new Date(endDate).getDate() <= new Date(startDate).getDate()) {
      setFieldError("endDate", "The end date must be after the start date");
    } else {
      setFieldError("endDate", undefined);
    }
  } else {
    setFieldError("endDate", undefined);
  }
};

export const startDateCheckErrorsOnChange = (
  startDate: Date,
  setFieldError: (field: string, message: string | undefined) => void,
) => {
  if (startDate) {
    if (startDate.getDate() < new Date().getDate()) {
      setFieldError("startDate", "Please choose a future or current date");
    } else {
      setFieldError("startDate", undefined);
    }
  } else {
    setFieldError("startDate", undefined);
  }
};

export const maxBidCheckErrorsOnChange = (
  maxBid: number,
  estimatedBudget: number,
  setFieldError: (field: string, message: string | undefined) => void,
) => {
  if ((maxBid as number) < 0 || !maxBid) {
    setFieldError("maxBid", "Number must be positive");
  } else if ((maxBid as number) > 100) {
    setFieldError("maxBid", "Max Bid can not exceed $100");
  } else if (maxBid > estimatedBudget) {
    setFieldError("maxBid", "Max Bid can not be greater than the Estimated Budget");
  } else {
    setFieldError("maxBid", undefined);
  }
};

export const calculateEstimatedBudget = (startDate: Date, endDate: Date, dailyBudget: number) => {
  const transformedStartDate = new Date(startDate);
  const transformedEndDate = new Date(endDate);
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const differenceInMilliseconds = Math.abs(transformedStartDate.getTime() - transformedEndDate.getTime());
  const days = Math.floor(differenceInMilliseconds / millisecondsPerDay);
  return dailyBudget * days;
};
